import { GLOBAL } from 'saddlebag-browser';

export const getURLSearchParams = (): URLSearchParams =>
  new URLSearchParams(GLOBAL.getWindow()?.location?.search);
